// extracted by mini-css-extract-plugin
export default {"container":"cfp_3Wjvr"};